import React, { forwardRef, useEffect, useRef } from "react";

import PropTypes from "prop-types";
import classNames from "classnames";
import "./styles.scss";

const TableCheckbox = forwardRef(({ indeterminate, classes, ...rest }, ref) => {
  const defaultRef = useRef();
  const resolvedRef = ref || defaultRef;

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={resolvedRef}
      {...rest}
      className={classNames("mydpd-dndtable-checkbox", classes)}
    />
  );
});

TableCheckbox.propTypes = {
  indeterminate: PropTypes.any,
  classes: PropTypes.string,
};

export default TableCheckbox;
